import { CommonModule } from '@angular/common';
import { NgModule, Optional, SkipSelf } from '@angular/core';
import { LoaderActionService } from '@core/service/loader-action.service';
import { AuthGuard } from './authentication/auth.guard';
import { CanDeactivateGuard } from './authentication/can-deactivate-guard.service';
import { PermissionCatalogGuard } from './authentication/permission-catalog.guard';
import { PermissionDformGuard } from './authentication/permission-dform.guard';
import { throwIfAlreadyLoaded } from './module-import-guard';
import { ActivityIndicatorSingletonService } from './service/activity-indicator-singleton.service';
import { DialogManagementService } from './service/dialog-management.service';
import { ToastService } from './service/toast.service';
import { UtilsShareService } from './service/utils_share.service';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [
    DialogManagementService,
    ToastService,
    ActivityIndicatorSingletonService,
    LoaderActionService,
    UtilsShareService,
    PermissionDformGuard,
    PermissionCatalogGuard,
    CanDeactivateGuard,
    AuthGuard,
  ]
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    throwIfAlreadyLoaded(parentModule, 'CoreModule');
  }
}
